import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import moment from "moment"
import DOMPurify from "dompurify"

import { Button, CheckboxField, DropDownField } from "../../../../helpers"

import SendEmail from "../../../../common/SendEmail"

import { raiseToast } from "../../../../services/redux/reducers/toast/toast"
import { DATE_FORMAT } from "../../../../constants"


const GrnConfirmModal = (props) => {
    const { 
        sellerPO, 
        handleAcceptClick,
        handleRejectClick,
        sellerPIPunchId, 
        sellerPoCreatedAtDate, 
        leadTime, 
        orderType,
        paymentModeOptions,
        updatedSellerPIPunchItems,
        materialDetails,
        sellerBillAddrDetails
    } = props

    const [paymentMode, setPaymentMode] = useState('')
    const [emailDetailsObj, setEmailDetailsObj] = useState({})
    const [isEmailDialogVisible, setIsEmailDialogVisible] = useState(false)
    const [skipEmail, setSkipEmail] = useState(false)

    const dispatch = useDispatch()
    const userDetails = useSelector(state => state.userDetails).userNameDetails

    const noOfDaysTakenToGrnDone = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(sellerPoCreatedAtDate).setHours(0, 0, 0, 0)) / (1000 * 60 * 60 * 24))

    let confirmDialogMessage = ""
    if (orderType?.orderTypeId === 3){
        confirmDialogMessage = "PO Qty will be converted to Stock. Are you sure you want to continue..?"
    }else{
        confirmDialogMessage = "Are you sure you want to continue..?"
    }

    let nonAdvancePaymentTermExists = false 
    if(sellerPO?.paymentTerms){
        let paymentTerms = sellerPO.paymentTerms
        const advancePaymentTerms = Object.keys(paymentTerms)
        const activePaymentTerms = advancePaymentTerms.filter(eachPaymentTerm => {
            if(paymentTerms[eachPaymentTerm]){
                return true
            }
            return false
        })
        nonAdvancePaymentTermExists = activePaymentTerms.some(element => ['payCredit', 'payOnDelivery'].includes(element))
    }

    const handlePaymentMode = (e) => {
        setPaymentMode(e.target.value)
    }

    const handleSubmit = () => {
        if(nonAdvancePaymentTermExists && !paymentMode){
            return dispatch(raiseToast({severity:'error', detail: 'select payment mode to proceed'}))
        }

        if (skipEmail) {
            handleAcceptClick({}, sellerPIPunchId, paymentMode)
        }else {
            let tableBorderStyle = "border: 1px solid black; border-collapse: collapse; padding: 3px; text-align: center;"
            let headerStyle = "color: black; font-weight: bold;"
            let tableDataStyle = "padding: 6px 18px;"
            let snoColumnStyle = "width: 50px;"

            let productsTableBodyString = ''
            updatedSellerPIPunchItems.map((item, index) => {
                const product = materialDetails.find(material => material.materialId === item.materialId)
                productsTableBodyString += `
                    <tr>
                        <td style="${tableBorderStyle}">${index + 1}</td>
                        <td style="${tableBorderStyle} ${tableDataStyle}">${product?.productName}</td>
                        <td style="${tableBorderStyle} ${tableDataStyle}">${product?.productSpecification}</td>
                        <td style="${tableBorderStyle} ${tableDataStyle}">${item.receivedQuantity}</td>
                        <td style="${tableBorderStyle} ${tableDataStyle}">${item.acceptedQuantity}</td>
                    </tr>
                `
            })

            let htmlString = `
                    <div style="font-family: Arial, sans-serif;">
                        <img alt="ProcMart Logo" src="https://procmart-dev.s3.ap-south-1.amazonaws.com/logo.png">
                        <br />
                        <p>Dear ${sellerBillAddrDetails.sellerUserName},</p>
                        <p>Greetings from ProcMart! </p>
                        <p>The material sent against Purchase Order - ${sellerPO.docNo} - dated: ${moment(sellerPO.createdAt).format(DATE_FORMAT)} has been successfully received by ProcMart. <br/>
                        Please find the details of all materials received up to now below: </p>
                        <table style="border: 1px solid black; border-collapse: collapse; width: 100%; table-layout: fixed;">
                            <thead>
                                <tr>
                                    <td style="${tableBorderStyle} ${headerStyle} ${snoColumnStyle}">S.No</td>
                                    <td style="${tableBorderStyle} ${headerStyle}">Product Name</td>
                                    <td style="${tableBorderStyle} ${headerStyle}">Product Specifications</td>
                                    <td style="${tableBorderStyle} ${headerStyle}">Received Qty</td>
                                    <td style="${tableBorderStyle} ${headerStyle}">Accepted Qty</td>
                                </tr>
                            </thead>
                            <tbody>
                                ${productsTableBodyString}
                            </tbody>
                        </table>
                        <p>Should you have any questions or require further information, please do not hesitate to reach out.</p>
                        <p>Best regards,<br/>${userDetails.firstName + " " + userDetails.lastName}<br/>+${userDetails.phoneNumber.slice(0, 2)}-${userDetails.phoneNumber.slice(2)}</p>
                    </div>
                `
            let sanitizedHTML = DOMPurify.sanitize(htmlString)

            const emailDetailObj = {
                to: sellerBillAddrDetails.email,
                from: userDetails.emailId,
                kam: userDetails.emailId,
                subject: `Confirmation of Material Receipt Against Purchase Order - ${sellerPO.docNo}`,
                message: sanitizedHTML,
                cc: []
            }
            setEmailDetailsObj(emailDetailObj)
            setIsEmailDialogVisible(true)
        }
    }

    const handleCheckboxChange = (e) => {
        setSkipEmail(e.target.checked)
        if (e.target.checked) {
            setEmailDetailsObj({})
        }
    }

    const handleMail = (emailObj) => {
        let sanitizedHTML = DOMPurify.sanitize(emailObj?.message)
        emailObj = {...emailObj, message: sanitizedHTML, cc: [...emailObj?.cc, userDetails?.emailId]}
        handleAcceptClick(emailObj, sellerPIPunchId, paymentMode)
        setEmailDetailsObj({})
    }

    return (
        <div className="p-card flex flex-column pb-2">
            <p>{`GRN Done in ${noOfDaysTakenToGrnDone} days against a lead time of ${leadTime} days!`} </p>
            {
                nonAdvancePaymentTermExists && (
                    <div className="flex flex-column col-12 mb-4 lg:col-6 lg:mb-0">
                        <DropDownField name="paymentMode" labelText="Select Payment Mode" options={paymentModeOptions} value={paymentMode} onChange={(event) => handlePaymentMode(event)} />
                    </div>
                )
            }
            <p>{confirmDialogMessage}</p>
            <br /> <br />
            <div className="flex flex-row align-items-center justify-content-between mb-3">
                {<CheckboxField label="Skip GRN Email To Vendor" checked={skipEmail} onChange={handleCheckboxChange} />}
                <div>
                    <Button label="Submit" className="p-button p-button-success mr-2" style={{ backgroundColor: "#00baaa" }} onClick={() => { handleSubmit(sellerPIPunchId) }} applyThrottle={true} />
                    <Button label="Cancel" className="p-button p-button-danger" onClick={() => { handleRejectClick(sellerPIPunchId) }} />
                </div>
            </div>
            <SendEmail emailDetailsObj={emailDetailsObj} visible={isEmailDialogVisible} handleSendMail={handleMail} setEmailDetailsObj={setEmailDetailsObj} onHide={() => setIsEmailDialogVisible(current => !current)}/>
        </div>
    )
}

export default GrnConfirmModal